import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../features/snackbar';
import ChannelForm from './ChannelForm';
import { updateChannel } from '../../features/netfeedr';

const DIALOG_ID = "editChannel"
const DIALOG_WIDTH = "md"

function EditChannelDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const channel = useSelector((state) => state.dialog[DIALOG_ID])
    const show = !!channel;
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({});

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();

        setLoading(true);
        dispatch(updateChannel({ 
            id: channel.id,
            ...form 
        }))
        .then(r => {
            if(r.payload){
                if(r.payload.error){
                    dispatch(enqueueErrorSnack(r.payload.error));
                }else{
                    dispatch(closeDialog(DIALOG_ID));
                    dispatch(enqueueSuccessSnack("Channel updated successfully"));    
                }
            }
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    
    useEffect(() => {
        if (channel && show) {
            setForm({
                channelId: channel.channelId || '',
                channelName: channel.channelName || '',
                platform: channel.platform || '',
                tier: 4,
                active: true
            });
        }
    }, [channel, show])

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={save}>
            <DialogTitle>
                Edit Channel
            </DialogTitle>
            <DialogContent dividers={false}>

                <Box pr={3}>
                    <ChannelForm form={form} onChange={setForm} errors={errors} />
                </Box> 
                
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="secondary" type="submit">Update Channel</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default EditChannelDialog;